import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../axiosInstance";
import "../styles/UserProfile.css";
import VideoGrid from "../components/VideoGrid";

// Modals
import PhotoModal from "../components/PhotoModal";
import BioModal from "../components/BioModal";
import StoryModal from "../components/StoryModal";
import RadialMenu from "../components/RadialMenu";

function UserProfile() {
  const { pseudo } = useParams();

  const [user, setUser] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showMenu, setShowMenu] = useState(false);
  const [showPhoto, setShowPhoto] = useState(false);
  const [showBio, setShowBio] = useState(false);

  const [hasStory, setHasStory] = useState(false);
  const [showStory, setShowStory] = useState(false);

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  useEffect(() => {
    let ok = true;

    const go = async () => {
      setLoading(true);
      try {
        const u = await API.get(
          `/users/by-pseudo/${encodeURIComponent(pseudo)}`
        );
        if (!ok) return;
        setUser(u.data);

        try {
          const v = await API.get(`/videos/by-user/${u.data.email}`);
          if (ok) setVideos(Array.isArray(v.data) ? v.data : []);
        } catch {
          if (ok) setVideos([]);
        }

        try {
          const s = await API.get(`/stories/user/${u.data.id}`);
          if (ok) setHasStory(Array.isArray(s.data) && s.data.length > 0);
        } catch {
          if (ok) setHasStory(false);
        }
      } catch {
        if (ok) {
          setUser(null);
          setVideos([]);
          setHasStory(false);
        }
      } finally {
        if (ok) setLoading(false);
      }
    };

    go();
    return () => {
      ok = false;
    };
  }, [pseudo]);

  if (loading)
    return <div className="user-profile-page">Chargement…</div>;

  if (!user)
    return <div className="user-profile-page">Utilisateur introuvable.</div>;

  // ✅ PROPRIÉTAIRE UNIQUEMENT
  const isOwner =
    currentUser &&
    (currentUser.email === user.email ||
      currentUser.pseudo === user.pseudo);

  return (
    <div className="user-profile-page">
      {/* 🟡 COFFRE → SEULEMENT PROPRIÉTAIRE */}
      {isOwner && (
        <div className="vault-floating">
          <button
            className="vault-btn"
            onClick={() => (window.location.href = "/coffre")}
          >
            🟡 {currentUser?.coins ?? 0}
          </button>
        </div>
      )}

      {/* MENU RADIAL */}
      {isOwner && (
        <div className="radial-container">
          <RadialMenu />
        </div>
      )}

      {/* AVATAR + STORY */}
      <div className="user-avatar-wrapper">
        <div
          className={`avatar-story-wrapper ${hasStory ? "has-story" : ""}`}
          onClick={() => hasStory && setShowStory(true)}
          style={{ cursor: hasStory ? "pointer" : "default" }}
        >
          <img
            src={
              user.profile_picture
                ? `/api/uploads/${user.profile_picture}`
                : "/api/uploads/default.png"
            }
            alt="avatar"
            className="user-avatar"
          />
        </div>

        {/* ➕ BOUTON */}
        {isOwner && (
          <>
            <div
              className="plus-profile-btn"
              onClick={() => setShowMenu(!showMenu)}
            >
              +
            </div>

            {showMenu && (
              <div className="profile-menu">
                <button
                  onClick={() => {
                    setShowPhoto(true);
                    setShowMenu(false);
                  }}
                >
                  📷 Photo
                </button>

                <button
                  onClick={() => {
                    window.location.href = "/story/create";
                  }}
                >
                  🟣 Story
                </button>

                <button
                  onClick={() => {
                    setShowBio(true);
                    setShowMenu(false);
                  }}
                >
                  ✍️ Bio
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* INFOS */}
      <h1>@{user.pseudo}</h1>
      <p>{user.bio || "Pas de bio."}</p>

      {/* STATS */}
      <div className="user-stats-row">
        <div className="user-stat">
          <span className="user-stat-number">{user.following || 0}</span>
          <span className="user-stat-label">Suivis</span>
        </div>
        <div className="user-stat">
          <span className="user-stat-number">{user.followers || 0}</span>
          <span className="user-stat-label">Followers</span>
        </div>
        <div className="user-stat">
          <span className="user-stat-number">{user.likes || 0}</span>
          <span className="user-stat-label">Likes</span>
        </div>
      </div>

      {/* VIDÉOS */}
      <div className="video-grid-container">
        {videos.length === 0 ? (
          <p style={{ marginTop: 20 }}>Aucune vidéo.</p>
        ) : (
          <VideoGrid videos={videos} />
        )}
      </div>

      {/* MODALS */}
      {isOwner && showPhoto && (
        <PhotoModal onClose={() => setShowPhoto(false)} />
      )}
      {isOwner && showBio && (
        <BioModal onClose={() => setShowBio(false)} />
      )}
      {showStory && (
        <StoryModal
          userId={user.id}
          onClose={() => setShowStory(false)}
        />
      )}
    </div>
  );
}

export default UserProfile;
